import React, { useState } from 'react';
import { Boxes } from 'lucide-react';
import StockAdjustModal from './StockAdjustModal';
import { useLanguage } from '../../contexts/LanguageContext';

const StockAdjustButton = ({ item, onDone }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="inline-flex items-center gap-2 px-3 py-1 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
        title={t('adjustStock')}
      >
        <Boxes className="w-4 h-4" />
        {t('stock')}
      </button>
      {isOpen && (
        <StockAdjustModal
          itemId={item.id || item.oil}
          itemLabel={item.oil || `${item.size} (${item.gender})`}
          initialStock={item.actualstock}
          onDone={(newStock) => {
            onDone(newStock);
            setIsOpen(false);
          }}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default StockAdjustButton;